<template>
<div>
    <Breadcrumbs main="Admin" submain="" title="ড্যাশবোর্ড (Dashboard)" />
    <div v-if="role === 'admin'">
        <div class="container-fluid">
            <div class="row mt-2">
                <div class="col-md-3">
                    <h7>অঞ্চল</h7>
                    <b-form-select v-model="onchol" :options="formattedOnchols" @change="onOncholChange" placeholder="Select a Ward"></b-form-select>
                </div>
                <div class="col-md-3">
                    <h7>ওয়ার্ড নং</h7>
                    <b-form-select v-model="ward_no" :options="formattedWards" placeholder="Select a Ward"></b-form-select>
                </div>
                <div class="col-md-2">
                    <div>
                        <h7>শুরুর তারিখ</h7>
                        <datepicker placeholder="Select a Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="start_date"></datepicker>
                    </div>
                </div>
                <div class="col-md-2">
                    <div>
                        <h7>শেষ তারিখ</h7>
                        <datepicker placeholder="Select a Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="end_date"></datepicker>
                    </div>
                </div>
                <div class="col-md-2">
                    <div style="margin-top: 21px; display: flex; gap: 12px; align-items: center; justify-content: center; color: white; background-color: #DC3545; padding: 7px 14px; min-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()">
                        <feather type="x"></feather>
                        <h7>Clear Filter</h7>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid mt-4">
            <div class="row">
                <div class="col-sm-12">
                    <px-card>
                        <div slot="with-padding">
                            <div style="width: 100%;" v-if="!loading && !error">
                                <div v-if="download_report">
                                    <div>
                                        <div>
                                            <div style="display: flex; align-items: end; gap: 16px; justify-content: end;">
                                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #dc3545; padding: 7px 24px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="cancelDownload()">
                                                    <h7>Cancel</h7>
                                                </div>
                                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #00984a; padding: 7px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="downloadAsPDF()">
                                                    <h7>Download</h7>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="download-pdf">
                                            <div style="display: flex; align-items: start; gap: 16px; justify-content: space-between; margin-top: 28px;">
                                                <img style="height: 90px;" src="https://api.fairdhaka.com/media/dncc.png" alt=""> 
                                                <p>{{ currentDateTime }}</p>
                                            </div>
                                            <p style="font-size: x-large; font-weight: 600; margin-top: 20px;">ডিএনসিসি অভিযোগ প্রতিবেদন</p>
                                            <div style="display: flex; flex-direction: column; gap: 4px; font-size: medium;">
                                                <div v-if="getSelectedOnchol" style="display: flex; flex-direction: row; gap: 8px;">
                                                    <span style="width: 90px;">Zone</span><span>:</span><span>{{ getSelectedOnchol }}</span>
                                                </div>
                                                <div v-if="getSelectedWard" style="display: flex; flex-direction: row; gap: 8px;">
                                                    <span style="width: 90px;">Ward No</span><span>:</span><span>{{ getSelectedWard }}</span>
                                                </div>
                                                <div v-if="formattedDateRange" style="display: flex; flex-direction: row; gap: 8px;">
                                                    <span style="width: 90px;">Date</span><span>:</span><span>{{ formattedDateRange }}</span>
                                                </div>
                                            </div>
                                            <div style="margin-top: 22px;">
                                                <b-table show-empty :items="count_array" :fields="tablefields">
                                                    <template #cell(title)="row">
                                                        <div style="min-width: 150px;">
                                                            <p>{{ row.item.title }}</p>
                                                        </div>
                                                    </template>
                                                    <template #cell(total)="row">
                                                        <div style="min-width: 100px;">
                                                            <p>{{ row.item.total }}</p>
                                                        </div>
                                                    </template>
                                                    <template #cell(pending)="row">
                                                        <div style="min-width: 100px;">
                                                            <p>{{ row.item.pending }}</p>
                                                        </div>
                                                    </template>
                                                    <template #cell(acknowledged)="row">
                                                        <div style="min-width: 100px;">
                                                            <p>{{ row.item.acknowledged }}</p>
                                                        </div>
                                                    </template>
                                                    <template #cell(in_progress)="row">
                                                        <div style="min-width: 100px;">
                                                            <p>{{ row.item.in_progress }}</p>
                                                        </div>
                                                    </template>
                                                    <template #cell(resolved)="row">
                                                        <div style="min-width: 100px;">
                                                            <p>{{ row.item.resolved }}</p>
                                                        </div>
                                                    </template>
                                                    <template #cell(rejected)="row">
                                                        <div style="min-width: 100px;">
                                                            <p>{{ row.item.rejected }}</p>
                                                        </div>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="d-flex flex-column flex-md-row">
                                        <div class="col-md-3"></div>
                                        <div class="col-md-6 margin-botton">
                                            <router-link :to="{ path: '/admin/complaints/illegal_structure' }">
                                                <div style="background-color: #e5f4ed; color: black; padding: 16px;" class="border-class">
                                                    <div>
                                                        <div class="title">মোট অভিযোগ (Total Complaints)
                                                            <span>
                                                                <feather class="text-center" type="external-link" size="22"></feather>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div style="display: flex; flex-direction: row; margin-top: 20px;">
                                                        <div style="display: flex; flex-direction: column; gap: 4px; width: 50%;">
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 180px;">Pending</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.status_wise_count" style="margin-right: 30px;">{{ dashboard_count.status_wise_count.pending }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 180px;">Acknowledged</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.status_wise_count" style="margin-right: 30px;">{{ dashboard_count.status_wise_count.acknowledged }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 180px;">In Progress</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.status_wise_count" style="margin-right: 30px;">{{ dashboard_count.status_wise_count.in_progress }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 180px;">Rejected</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.status_wise_count" style="margin-right: 30px;">{{ dashboard_count.status_wise_count.rejected }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style="width: 50%;" class="count" v-if="dashboard_count">
                                                            <span><span>{{ dashboard_count.status_wise_count.resolved }} / </span><span>{{ dashboard_count.total_complaint }}</span></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </div>
                                        <div class="col-md-3">
                                            <div style="display: flex; align-items: end; justify-content: end;">
                                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #00984a; padding: 7px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="downloadReport()">
                                                    <h7>Download Report</h7>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="d-flex flex-column flex-md-row margin-top">
                                        <div class="col-md-4">
                                            <router-link :to="{ path: '/admin/complaints/road' }">
                                                <div style="background-color: #e5f4ed; color: black; padding: 16px;" class="border-class">
                                                    <div>
                                                        <div class="title">রাস্তা (Road)
                                                            <span>
                                                                <feather class="text-center" type="external-link" size="22"></feather>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div style="display: flex; flex-direction: row; margin-top: 20px;">
                                                        <div style="display: flex; flex-direction: column; gap: 4px; width: 50%; margin-top: 4px;">
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Pending</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.road" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.road.pending }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Acknowledged</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.road" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.road.acknowledged }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">In Progress</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.road" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.road.in_progress }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Rejected</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.road" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.road.rejected }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style="width: 50%;" class="count" v-if="dashboard_count">
                                                            <span v-if="dashboard_count.category_wise_count.road"><span>{{ dashboard_count.category_wise_count.road.resolved }} / </span>{{ dashboard_count.category_wise_count.road.total }}</span>
                                                        </div>
                                                    </div>  
                                                </div>
                                            </router-link>
                                        </div>
                                        <div class="col-md-4 margin-y-axis">
                                            <router-link :to="{ path: '/admin/complaints/mosquito' }">
                                                <div style="background-color: #e5f4ed; color: black; padding: 16px;" class="border-class">
                                                    <div>
                                                        <div class="title">মশা (Mosquito)
                                                            <span>
                                                                <feather class="text-center" type="external-link" size="22"></feather>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div style="display: flex; flex-direction: row; margin-top: 20px;">
                                                        <div style="display: flex; flex-direction: column; gap: 4px; width: 50%; margin-top: 4px;">
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Pending</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.mosquito" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.mosquito.pending }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Acknowledged</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.mosquito" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.mosquito.acknowledged }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">In Progress</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.mosquito" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.mosquito.in_progress }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Rejected</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.mosquito" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.mosquito.rejected }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style="width: 50%;" class="count" v-if="dashboard_count">
                                                            <span v-if="dashboard_count.category_wise_count.mosquito"><span>{{ dashboard_count.category_wise_count.mosquito.resolved }} / </span>{{ dashboard_count.category_wise_count.mosquito.total }}</span>
                                                        </div>
                                                    </div>  
                                                </div>
                                            </router-link>
                                        </div>
                                        <div class="col-md-4 margin-botton">
                                            <router-link :to="{ path: '/admin/complaints/garbage' }">
                                                <div style="background-color: #e5f4ed; color: black; padding: 16px;" class="border-class">
                                                    <div>
                                                        <div class="title">বর্জ্য (Waste)
                                                            <span>
                                                                <feather class="text-center" type="external-link" size="22"></feather>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div style="display: flex; flex-direction: row; margin-top: 20px;">
                                                        <div style="display: flex; flex-direction: column; gap: 4px; width: 50%; margin-top: 4px;">
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Pending</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.garbage" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.garbage.pending }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Acknowledged</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.garbage" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.garbage.acknowledged }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">In Progress</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.garbage" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.garbage.in_progress }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Rejected</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.garbage" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.garbage.rejected }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style="width: 50%;" class="count" v-if="dashboard_count">
                                                            <span v-if="dashboard_count.category_wise_count.garbage"><span>{{ dashboard_count.category_wise_count.garbage.resolved }} / </span>{{ dashboard_count.category_wise_count.garbage.total }}</span>
                                                        </div>
                                                    </div>  
                                                </div>
                                            </router-link>
                                        </div>
                                    </div>

                                    <div class="d-flex flex-column flex-md-row margin-top">
                                        <div class="col-md-4">
                                            <router-link :to="{ path: '/admin/complaints/street_light' }">
                                                <div style="background-color: #e5f4ed; color: black; padding: 16px;" class="border-class">
                                                    <div>
                                                        <div class="title">রাস্তার বাতি (Street Light)
                                                            <span>
                                                                <feather class="text-center" type="external-link" size="22"></feather>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div style="display: flex; flex-direction: row; margin-top: 20px;">
                                                        <div style="display: flex; flex-direction: column; gap: 4px; width: 50%; margin-top: 4px;">
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Pending</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.street_light" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.street_light.pending }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Acknowledged</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.street_light" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.street_light.acknowledged }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">In Progress</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.street_light" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.street_light.in_progress }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Rejected</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.street_light" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.street_light.rejected }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style="width: 50%;" class="count" v-if="dashboard_count">
                                                            <span v-if="dashboard_count.category_wise_count.street_light"><span>{{ dashboard_count.category_wise_count.street_light.resolved }} / </span>{{ dashboard_count.category_wise_count.street_light.total }}</span>
                                                        </div>
                                                    </div>  
                                                </div>
                                            </router-link>
                                        </div>
                                        <div class="col-md-4 margin-y-axis">
                                            <router-link :to="{ path: '/admin/complaints/public_toilet' }">
                                                <div style="background-color: #e5f4ed; color: black; padding: 16px;" class="border-class">
                                                    <div>
                                                        <div class="title">পাবলিক টয়লেট (Public Toilet)
                                                            <span>
                                                                <feather class="text-center" type="external-link" size="22"></feather>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div style="display: flex; flex-direction: row; margin-top: 20px;">
                                                        <div style="display: flex; flex-direction: column; gap: 4px; width: 50%; margin-top: 4px;">
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Pending</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.public_toilet" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.public_toilet.pending }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Acknowledged</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.public_toilet" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.public_toilet.acknowledged }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">In Progress</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.public_toilet" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.public_toilet.in_progress }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Rejected</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.public_toilet" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.public_toilet.rejected }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style="width: 50%;" class="count" v-if="dashboard_count">
                                                            <span v-if="dashboard_count.category_wise_count.public_toilet"><span>{{ dashboard_count.category_wise_count.public_toilet.resolved }} / </span>{{ dashboard_count.category_wise_count.public_toilet.total }}</span>
                                                        </div>
                                                    </div>  
                                                </div>
                                            </router-link>
                                        </div>
                                        <div class="col-md-4 margin-botton">
                                            <router-link :to="{ path: '/admin/complaints/drainage' }">
                                                <div style="background-color: #e5f4ed; color: black; padding: 16px;" class="border-class">
                                                    <div>
                                                        <div class="title">নিষ্কাশন ব্যবস্থা (Drainage)
                                                            <span>
                                                                <feather class="text-center" type="external-link" size="22"></feather>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div style="display: flex; flex-direction: row; margin-top: 20px;">
                                                        <div style="display: flex; flex-direction: column; gap: 4px; width: 50%; margin-top: 4px;">
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Pending</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.drainage" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.drainage.pending }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Acknowledged</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.drainage" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.drainage.acknowledged }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">In Progress</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.drainage" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.drainage.in_progress }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Rejected</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.drainage" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.drainage.rejected }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style="width: 50%;" class="count" v-if="dashboard_count">
                                                            <span v-if="dashboard_count.category_wise_count.drainage"><span>{{ dashboard_count.category_wise_count.drainage.resolved }} / </span>{{ dashboard_count.category_wise_count.drainage.total }}</span>
                                                        </div>
                                                    </div> 
                                                </div>
                                            </router-link>
                                        </div>
                                    </div>

                                    <div class="d-flex flex-column flex-md-row margin-top">
                                        <div class="col-md-4 margin-botton">
                                            <router-link :to="{ path: '/admin/complaints/illegal_structure' }">
                                                <div style="background-color: #e5f4ed; color: black; padding: 16px;" class="border-class">
                                                    <div>
                                                        <div class="title">অবৈধ কাঠামো (Illegal Structure)
                                                            <span>
                                                                <feather class="text-center" type="external-link" size="22"></feather>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div style="display: flex; flex-direction: row; margin-top: 20px;">
                                                        <div style="display: flex; flex-direction: column; gap: 4px; width: 50%; margin-top: 4px;">
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Pending</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.illegal_structure" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.illegal_structure.pending }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Acknowledged</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.illegal_structure" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.illegal_structure.acknowledged }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">In Progress</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.illegal_structure" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.illegal_structure.in_progress }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Rejected</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.illegal_structure" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.illegal_structure.rejected }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style="width: 50%;" class="count" v-if="dashboard_count">
                                                            <span v-if="dashboard_count.category_wise_count.illegal_structure"><span>{{ dashboard_count.category_wise_count.illegal_structure.resolved }} / </span>{{ dashboard_count.category_wise_count.illegal_structure.total }}</span>
                                                        </div>
                                                    </div> 
                                                </div>
                                            </router-link>
                                        </div>
                                        <div class="col-md-4 margin-botton">
                                            <router-link :to="{ path: '/admin/complaints/waterlog' }">
                                                <div style="background-color: #e5f4ed; color: black; padding: 16px;" class="border-class">
                                                    <div>
                                                        <div class="title">জলাবদ্ধতা (Waterlog)
                                                            <span>
                                                                <feather class="text-center" type="external-link" size="22"></feather>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div style="display: flex; flex-direction: row; margin-top: 20px;">
                                                        <div style="display: flex; flex-direction: column; gap: 4px; width: 50%; margin-top: 4px;">
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Pending</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.waterlog" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.waterlog.pending }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Acknowledged</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.waterlog" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.waterlog.acknowledged }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">In Progress</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.waterlog" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.waterlog.in_progress }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Rejected</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.waterlog" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.waterlog.rejected }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style="width: 50%;" class="count" v-if="dashboard_count">
                                                            <span v-if="dashboard_count.category_wise_count.waterlog"><span>{{ dashboard_count.category_wise_count.waterlog.resolved }} / </span>{{ dashboard_count.category_wise_count.waterlog.total }}</span>
                                                        </div>
                                                    </div> 
                                                </div>
                                            </router-link>
                                        </div>
                                        <div class="col-md-4 margin-botton">
                                            <router-link :to="{ path: '/admin/complaints/waterlog' }">
                                                <div style="background-color: #e5f4ed; color: black; padding: 16px;" class="border-class">
                                                    <div>
                                                        <div class="title">বায়ু দূষণ (Air Pollution)
                                                            <span>
                                                                <feather class="text-center" type="external-link" size="22"></feather>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div style="display: flex; flex-direction: row; margin-top: 20px;">
                                                        <div style="display: flex; flex-direction: column; gap: 4px; width: 50%; margin-top: 4px;">
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Pending</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.noise_pollution" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.noise_pollution.pending }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Acknowledged</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.noise_pollution" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.noise_pollution.acknowledged }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">In Progress</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.noise_pollution" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.noise_pollution.in_progress }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Rejected</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.noise_pollution" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.noise_pollution.rejected }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style="width: 50%;" class="count" v-if="dashboard_count">
                                                            <span v-if="dashboard_count.category_wise_count.noise_pollution"><span>{{ dashboard_count.category_wise_count.noise_pollution.resolved }} / </span>{{ dashboard_count.category_wise_count.noise_pollution.total }}</span>
                                                        </div>
                                                    </div> 
                                                </div>
                                            </router-link>
                                        </div>
                                    </div>

                                    <div class="d-flex flex-column flex-md-row margin-top">
                                        <div class="col-md-2"></div>
                                        <div class="col-md-4 margin-botton">
                                            <router-link :to="{ path: '/admin/complaints/waterlog' }">
                                                <div style="background-color: #e5f4ed; color: black; padding: 16px;" class="border-class">
                                                    <div>
                                                        <div class="title">শব্দ দূষণ (Noise Pollution)
                                                            <span>
                                                                <feather class="text-center" type="external-link" size="22"></feather>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div style="display: flex; flex-direction: row; margin-top: 20px;">
                                                        <div style="display: flex; flex-direction: column; gap: 4px; width: 50%; margin-top: 4px;">
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Pending</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.air_pollution" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.air_pollution.pending }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Acknowledged</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.air_pollution" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.air_pollution.acknowledged }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">In Progress</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.air_pollution" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.air_pollution.in_progress }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Rejected</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.air_pollution" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.air_pollution.rejected }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style="width: 50%;" class="count" v-if="dashboard_count">
                                                            <span v-if="dashboard_count.category_wise_count.air_pollution"><span>{{ dashboard_count.category_wise_count.air_pollution.resolved }} / </span>{{ dashboard_count.category_wise_count.air_pollution.total }}</span>
                                                        </div>
                                                    </div> 
                                                </div>
                                            </router-link>
                                        </div>
                                        <div class="col-md-4 margin-botton">
                                            <router-link :to="{ path: '/admin/complaints/waterlog' }">
                                                <div style="background-color: #e5f4ed; color: black; padding: 16px;" class="border-class">
                                                    <div>
                                                        <div class="title">মতামত (Remarks)
                                                            <span>
                                                                <feather class="text-center" type="external-link" size="22"></feather>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div style="display: flex; flex-direction: row; margin-top: 20px;">
                                                        <div style="display: flex; flex-direction: column; gap: 4px; width: 50%; margin-top: 4px;">
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Pending</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.remarks" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.remarks.pending }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Acknowledged</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.remarks" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.remarks.acknowledged }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">In Progress</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.remarks" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.remarks.in_progress }}</span>
                                                                </div>
                                                            </div>
                                                            <div style="display: flex; flex-direction: row; font-size: medium; font-size: small; color: gray;">
                                                                <div style="width: 160px;">Rejected</div>
                                                                <div v-if="dashboard_count">
                                                                    <span v-if="dashboard_count.category_wise_count.remarks" style="margin-right: 30px;">{{ dashboard_count.category_wise_count.remarks.rejected }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style="width: 50%;" class="count" v-if="dashboard_count">
                                                            <span v-if="dashboard_count.category_wise_count.remarks"><span>{{ dashboard_count.category_wise_count.remarks.resolved }} / </span>{{ dashboard_count.category_wise_count.remarks.total }}</span>
                                                        </div>
                                                    </div> 
                                                </div>
                                            </router-link>
                                        </div>
                                        <div class="col-md-2"></div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <loader />
                            </div>
                        </div>
                    </px-card>
                </div>
            </div>
        </div>
    </div> 
    <div class="container-fluid mt-4" v-else>
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div style="height: calc(100vh - 200px); text-align: center; padding: 80px 20px;">
                        <h5>Welcome to Fair Dhaka Admin Dashboard</h5>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import loader from '../loader/loader.vue';
import moment from "moment";

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        Multiselect,
        loader
    },

    data() {
        return {
            role: '',
            download_report: false,
            currentDateTime: '',
            onchol: null,
            ward_no: null,
            start_date: null,
            end_date: null,
            initialLoad: true,
            count_array: [],
            tablefields: [
                {
                    key: 'title',
                    label: 'Type',
                    sortable: false
                },
                {
                    key: 'total',
                    label: 'Total',
                    sortable: false
                },
                {
                    key: 'pending',
                    label: 'Pending',
                    sortable: false
                },
                {
                    key: 'acknowledged',
                    label: 'Acknowledged',
                    sortable: false
                },
                {
                    key: 'in_progress',
                    label: 'In Progress',
                    sortable: false
                },
                {
                    key: 'resolved',
                    label: 'Resolved',
                    sortable: false
                },
                {
                    key: 'rejected',
                    label: 'Rejected',
                    sortable: false
                }
            ]
        }
    },

    computed: {
        ...mapState({
            wards: state => state.issue.wards,
            onchols: state => state.issue.onchols,
            dashboard_count: state => state.issue.dashboard_count,
            count_live_list: state => state.dashboard.dashboadr_count_by_shelter_live,

            loading: state => state.dashboard.dashboardCountLoading,
            error: state => state.dashboard.dashboardCountError,
        }),

        formattedWards() {
            return this.wards.map(ward => {
                return {
                    value: ward?.id,
                    text: `${ward?.bangla_name} (${ward?.name})`
                };
            });
        },
        
        formattedOnchols() {
            return this.onchols.map(onchol => {
                return {
                    value: onchol?.id,
                    text: `${onchol?.bangla_name} (${onchol?.name})`
                };
            });
        },

        getSelectedOnchol() {
            const selected = this.formattedOnchols.find(item => item.value === this.onchol);
            return selected ? selected.text : null;
        },

        getSelectedWard() {
            const selected = this.formattedWards.find(item => item.value === this.ward_no);
            return selected ? selected.text : null;
        },

        formattedDateRange() {
            if (!this.start_date) return null;

            const format = (dateStr) => {
                const date = new Date(dateStr);
                return date.toLocaleDateString("en-US", {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
            };

            const start = format(this.start_date);
            const end = this.end_date ? format(this.end_date) : null;

            return end ? `${start} - ${end}` : start;
        }
    },

    watch: {
        dashboard_count(newValue, oldValue) {

        },

        count_live_list(newValue, oldValue) {

        },

        onchol() {
            this.updateQuery();
        },
        ward_no() {
            this.updateQuery();
        },
        start_date() {
            this.updateQuery();
        },
        end_date() {
            this.updateQuery();
        }
    },

    mounted() {
        this.role = localStorage.getItem("role");
        if (localStorage.getItem('reloaded') == 'no') {
            localStorage.setItem('reloaded', 'yes')
            this.$router.go(0)
        }
        this.$store.dispatch('issue/getWards')
        this.$store.dispatch('issue/getOnchols')
        // this.$store.dispatch("issue/fetchCount");
        this.initializeCount();
        const now = new Date();
        this.currentDateTime = now.toLocaleString();
    },

    methods: {
        downloadReport() {
            this.download_report = true;
        },

        cancelDownload() {
            this.download_report = false;
        },

        downloadAsPDF() {
            const printContents = document.getElementById('download-pdf').innerHTML;
            const originalContents = document.body.innerHTML;

            document.body.innerHTML = printContents;
            window.print();
            document.body.innerHTML = originalContents;
            window.location.reload();
        },

        initializeCount() {
            const { ward_no, onchol, start_date, end_date } = this.$route.query;

            this.onchol = onchol ? parseInt(onchol) : null;
            this.ward_no = ward_no ? parseInt(ward_no) : null;
            this.start_date = start_date || null;
            this.end_date = end_date || null;

            if (ward_no || onchol || start_date || end_date) {
                // this.onchol = onchol || null;
                // this.ward_no = ward_no || null;
                // this.start_date = start_date || null;
                // this.end_date = end_date || null;

                this.fetchFilterCount();
            } else {
                this.$store.dispatch("issue/fetchCount", {onchol: this.onchol}).then(response => {
                    this.dashboard_count = response.data;
                    this.generateCountArray();
                })
                .catch(error => {
                    console.error("Failed to fetch count:", error);
                });
            }
        },

        generateCountArray() {
            const countList = [];

            // Total Complaint (from status-wise count)
            if (this.dashboard_count.status_wise_count) {
                countList.push({
                    title: "Total Complaint",
                    ...this.dashboard_count.status_wise_count
                });
            }

            // Category-wise complaints
            if (this.dashboard_count.category_wise_count) {
                for (const [key, value] of Object.entries(this.dashboard_count.category_wise_count)) {
                    countList.push({
                        title: key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
                        ...value
                    });
                }
            }

            this.count_array = countList;
        },

        onOncholChange() {
            this.$store.dispatch('issue/getWardsByOnchol', this.onchol)
        },

        updateQuery() {
            const query = {};

            if (this.onchol) query.onchol = this.onchol;
            if (this.ward_no) query.ward_no = this.ward_no;
            if (this.start_date) query.start_date = this.formatDate(this.start_date);
            if (this.end_date) query.end_date = this.formatDate(this.end_date);

            // Update the route without reloading the page
            this.$router.replace({ path: this.$route.path, query });

            this.fetchFilterCount();
        },

        formatDate(date) {
            if (!date) return null;
            const d = new Date(date);
            const month = `${d.getMonth() + 1}`.padStart(2, '0');
            const day = `${d.getDate()}`.padStart(2, '0');
            return `${d.getFullYear()}-${month}-${day}`;
        },

        fetchFilterCount() {
            this.$store.dispatch("issue/fetchCount", {
                ward_no: this.$route.query.ward_no,
                onchol: this.$route.query.onchol,
                start_date: this.$route.query.start_date,
                end_date: this.$route.query.end_date
            }).then(response => {
                this.dashboard_count = response.data;
                this.generateCountArray();
            })
            .catch(error => {
                console.error("Failed to fetch count:", error);
            });
        },

        clearFilter() {
            this.onchol = null;
            this.ward_no = null;
            this.start_date = null;
            this.end_date = null;

            this.$nextTick(() => {
                this.$router.replace({
                    path: '/dashboard', query: {}
                });
            });
        },
    }
};
</script>

<style scoped>
@media print {
  #download-pdf, #download-pdf * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}

.margin-y-axis {
    margin-top: 16px;
    margin-bottom: 16px;
}

.margin-top {
    margin-top: 24px;
}

.margin-botton {
    margin-bottom: 16px;
}

.border-class {
    border-radius: 0.375rem;
}

.title {
    font-size: large;
    font-weight: 500;
    color: #00984a;
}

.count {
    text-align: end;
    font-size: xx-large;
    font-weight: 500;
    margin-top: -1px;
}

.main-title {
    font-size: x-large;
    font-weight: 500;
}

@media (max-width: 1480px) {
    .main-title {
        font-size: large;
        font-weight: 500;
    }
}

@media (max-width: 767px) {
    .margin-top {
        margin-top: 0px;
    }
}

@media (min-width: 768px) {
    .margin-y-axis {
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .margin-botton {
        margin-bottom: 0px;
    }
}
</style>
